export default __webpack_public_path__ + "static/media/cart-blue.bc7b145e.svg";